export default __webpack_public_path__ + "static/media/player.7ba5ab4f.png";